module.exports = __webpack_public_path__ + "static/media/ourCharityLogo.e37920f2.jpg";